import React from 'react';
import PropTypes from 'prop-types';

function PrimaryButton({
  caption,
  className,
  textColor,
  bgColor,
  onClick,
  fontSize,
  disabled,
  fontWeight,
  border,
  borderColor,
  padding,
  id,
  lineHeight,
  isLoading
}) {
  return (
    <button
      id={id}
      disabled={disabled}
      style={{ fontSize: fontSize, padding: padding, lineHeight: lineHeight }}
      onClick={() => onClick && onClick()}
      className={`rounded relative cursor-pointer ${className} ${textColor} ${bgColor} ${fontWeight} ${border} ${borderColor}`}
    >
      {isLoading ? (
        <div className="w-5 flex self-center mx-auto -mt-2">
          <div className="loader"></div>
          <div className="text-transparent">loading</div>
        </div>
      ) : (
        caption
      )}
    </button>
  );
}
export default PrimaryButton;

PrimaryButton.propTypes = {
  caption: PropTypes.string,
  className: PropTypes.string,
  textColor: PropTypes.string,
  bgColor: PropTypes.string,
  onClick: PropTypes.func,
  fontSize: PropTypes.string,
  bgColor: PropTypes.string,
  disabled: PropTypes.bool,
  fontWeight: PropTypes.string,
  border: PropTypes.string,
  fontWeight: PropTypes.string,
  borderColor: PropTypes.string,
  padding: PropTypes.string,
  lineHeight: PropTypes.string
};

PrimaryButton.defaultProps = {
  padding: '11px 32px',
  textColor: 'text-white',
  fontSize: '12px',
  bgColor: 'bg-orange-500',
  lineHeight: '12px'
};
